import Dashboard from '../containers/dashboard'
import RequestedReportsManagement from '../containers/requested-reports-management'

const RequestedReports = () => {
  return (
    <Dashboard>
      <RequestedReportsManagement />
    </Dashboard>
  )
}

export default RequestedReports
